<template>
  <div>
    <section class="cart-section">
      <div class="container">
        <div class="">
          <div class="container padding-cls" style="margin-bottom:0px">
            <div class="checkout-page">
              <div class="checkout-form-1 theme-form">
                <div class="row center-content">
                  <div class="col-lg-12 col-sm-12 col-xs-12">
                    <div class="check-out ng-star-inserted">
                      <div class="row">
                        <div class="form-group col-md-8" style="margin-bottom:25px">
                          <div class="field-label" style="line-height:24px;margin-bottom:10px;padding-left: 5px;">Applied Unit/Subunit
                          </div>
                           <div class="unit-selection-grid">
                            <div
                              v-for="application in applications"
                              :key="application.id"
                              v-if="application.status == 'paid'"
                              class="unit-card"
                              :class="{
                                'unit-card-selected': unit === application.unit,
                                'unit-card-eligible': true
                              }"
                              @click="selectUnit(application.unit)"
                            >

                              <input
                                class="unit-radio-hidden"
                                v-model="unit"
                                type="radio"
                                name="unit"
                                :id="'unit'+application.unit"
                                :value="application.unit"
                                @change="getQuotaValues"
                              >

                              <div class="unit-card-content">
                                <div class="unit-check-indicator">
                                  <i v-if="unit === application.unit" class="fa fa-check-circle"></i>
                                  <i v-else class="fa fa-circle-o"></i>
                                </div>

                                <div class="unit-label">
                                  {{ application.unit }}
                                </div>
                              </div>

                            </div>
                          </div>

                        </div>
                        <div v-if="unit && quota && message == '' && !onResultLoading" class="col-md-4 col-xs-12"
                          style="padding-top: 10px;">
                          <!-- <router-link :to="'/result/' + unit + '/' + quota" target="_blank" style="margin:4px;float:right" class="btn light-btn btn-primary radius-1" type="button" block>
                            <i aria-hidden="true" class="fa fa-print"></i>
                          </router-link> -->

                          <button class="btn info-btn btn-info radius-1 d-flex align-items-center p-2 xs:p-0"
                            @click="downloadRESULT" :disabled="isDownloadingRESULT" type="button"
                            >
                            <!-- Icon always visible, changes to spinner when downloading -->
                            <i :class="isDownloadingRESULT ? 'fa fa-spinner fa-spin' : 'fa fa-download'"
                              aria-hidden="true" style="font-size: 1.2em;margin-right: 8px;"></i>

                            <!-- Message below icon -->
                            <span class="mt-1 text-center" style="font-size: 0.85rem;">
                              {{ isDownloadingRESULT ? resultProgress : 'Download RESULT PDF' }}
                            </span>
                          </button>


                        </div>
                      </div>

                      <div class="row">
                        <div v-if="unit && !onResultLoading" class="form-group col-md-12">
                          <div class="field-label" style="line-height:24px;padding-left: 5px;">Quota: </div>
                           <!-- <div class="form-check form-check-inline" v-for="tquota in quotas" :key="tquota">
                            <input class="form-check-input" v-model="quota" style="margin-top:.25em" type="radio"
                              name="quota" :id="'quota' + tquota" :value="tquota" @change="getExamResult">
                            <label class="form-check-label" :for="'quota' + tquota">{{ tquota }}</label>
                          </div> -->

                          <div class="quota-selection-grid">
                            <div
                              class="unit-card"
                              v-for="tquota in quotas"
                              :key="tquota"
                              :class="{ 'unit-card-selected': quota === tquota }"
                              @click="quota = tquota; getExamResult()"
                            >
                              <input
                                class="unit-radio-hidden"
                                v-model="quota"
                                type="radio"
                                name="quota"
                                :id="'quota' + tquota"
                                :value="tquota"
                              >

                              <div class="unit-card-content">
                                <div class="unit-check-indicator">
                                  <i v-if="quota === tquota" class="fa fa-check-circle"></i>
                                  <i v-else class="fa fa-circle-o"></i>
                                </div>

                                <div class="unit-label">{{ tquota }}</div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>

                      <div class="row">
                        <div class="middle-center" v-if="onResultLoading">
                          <global-spinner :animation-duration="1500" :size="50" color="#2196f3" />
                        </div>
                      </div>

                      <div class="row">
                        <div v-if="unit && quota && !onResultLoading" class="form-groupx col-md-12"
                          style="padding-top:10px">
                          <div v-if="message == ''" class="form-group col-md-12">
                            <div class="card" style="margin-top: 10px; border-top-left-radius:4%; border-top-right-radius:4%;">
                              <div class="card-header bg-dark text-white" style="font-weight:bold;">
                                Applicant's Info
                              </div>
                              <div class="card-bodyx table-responsive">
                                <table class="table" style="font-weight: bold;margin:auto">
                                  <tr>
                                    <td class="count-desc">Name</td>
                                    <td class="count-desc">:</td>
                                    <td class="count-desc">{{ this.applicant.name }}</td>
                                  </tr>
                                  <tr>
                                    <td class="count-desc">Father's Name</td>
                                    <td class="count-desc">:</td>
                                    <td class="count-desc">{{ this.applicant.fname }}</td>
                                  </tr>
                                  <tr>
                                    <td class="count-desc">Mother's Name</td>
                                    <td class="count-desc">:</td>
                                    <td class="count-desc">{{ this.applicant.mname }}</td>
                                  </tr>
                                  <tr>
                                    <td class="count-desc">Admission Roll</td>
                                    <td class="count-desc">:</td>
                                    <td class="count-desc">{{ this.application.exam_roll }}</td>
                                  </tr>
                                </table>
                              </div>
                            </div>

                            <div class="card mt-3" style="border-top-left-radius:4%; border-top-right-radius:4%;">
                              <div class="card-header bg-dark text-white" style="font-weight:bold">Marks obtained on
                                Admission Test</div>
                              <div class="card-bodyx table-responsive">
                                <table class="table" style="font-weight: bold;margin:auto; border-radius: 0px;">
                                  <tr class="table-success">
                                    <th class="count-desc w-50">Subject</th>
                                    <th class="count-desc text-center w-20">{{ unit === 'A' ? 'Number of Questions' : 'Total Marks' }}</th>
                                    <th class="count-desc text-right w-30">Gross Score</th>  
                                    <th class="count-desc text-right w-30">Deductions</th>  
                                    <th class="count-desc text-right w-30">Net Score</th>                                    
                                  </tr>
                                  <tr v-for="mark in examMarks">
                                    <td class="count-desc w-50">{{ mark.subject }}</td>
                                    <td class="count-desc text-center w-20">{{ mark.max }}</td>
                                    <td class="count-desc text-right w-30">{{ mark.correct }}</td>  
                                    <td class="count-desc text-right w-30">{{ mark.deduct }}</td>  
                                    <td class="count-desc text-right w-30">{{ mark.total }}</td>                                    
                                  </tr>
                                  <!-- <tr>
                                    <th class="count-desc">Total</th>
                                    <th class="count-desc text-center">100</th>
                                    <th class="count-desc text-right">{{ examResult.correct }}</th>
                                    
                                  </tr> -->
                                </table>
                              </div>
                            </div>

                            <div class="card mt-3 mb-5" style="border-top-left-radius:4%; border-top-right-radius:4%;">
                              <div class="card-header bg-dark text-white" style="font-weight:bold">Admission Test Result Summary</div>
                              <div class="card-bodyx table-responsive">
                                <table class="table" style="font-weight: bold;margin:auto">

                                  <!-- <tr>
                                    <td class="count-desc">Obtained Marks</td>
                                    <td class="count-desc"></td>
                                    <td class="count-desc"></td>
                                    <td class="count-desc text-right">{{ this.examResult.exam_score }}</td>
                                  </tr> -->
                                  
                                  <tr>
                                    <td class="count-desc">Deductions - Wrong Answers</td>
                                    <td class="count-desc"></td>
                                    <td class="count-desc"></td>
                                    <td class="count-desc text-right">{{ this.examResult.deduct }}</td>
                                  </tr>
                                  
                                  <tr v-if="this.examResult.penalty && this.examResult.penalty > 0">
                                    <td class="count-desc">Deductions - Irregular</td>
                                    <td class="count-desc"></td>
                                    <td class="count-desc"></td>
                                    <td class="count-desc text-right">{{ this.examResult.penalty }}</td>
                                  </tr>
                                  <tr>
                                    <th class="count-desc">Net Score</th>
                                    <td class="count-desc" style="border-bottom: 2px solid var(--cu-blue-200) !important;"></td>
                                    <td class="count-desc" style="border-bottom: 2px solid var(--cu-blue-200) !important;"></td>
                                    <th class="count-desc text-right">{{ this.examResult.total }}</th>
                                  </tr>
                                  <tr>
                                    <th class="count-desc">Result</th>
                                    <td class="count-desc" style="border-bottom: 2px solid var(--cu-blue-200) !important;"></td>
                                    <td class="count-desc" style="border-bottom: 2px solid var(--cu-blue-200) !important;"></td>
                                    <th class="count-desc text-right">{{ this.examResult.status }}</th>
                                    <!--th class="count-desc text-right">{{this.examResult.merit ? 'Pass' : 'Fail'}}</th-->
                                  </tr>
                                  <tr v-if="this.examResult.merit">
                                    <th class="count-desc">Merit Position</th>
                                    <td class="count-desc" style="border-bottom: 2px solid var(--cu-blue-200) !important;"></td>
                                    <td class="count-desc" style="border-bottom: 2px solid var(--cu-blue-200) !important;"></td>
                                    <th class="count-desc text-right">{{ this.examResult.merit }}</th>
                                  </tr>
                                </table>
                              </div>
                            </div>
                          </div>
                          <div v-else class="p-3 text-center">
                            <span style="margin-left: 20px; text-transform: uppercasex; color:RED;">{{ message }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Loader from '../Helper/Loader'
import { GET_EXAM_RESULT } from '../../const/api'
import { GET } from '../../utils/Request'

import ResultGenerator from '@/utils/ResultGenerator'
import '../../assets/css/new-unit-radio-grid.css'

export default {
  name: 'ProfileResult',
  components: { Loader },
  props: ['applications'],
  data() {
    return {
      onResultLoading: true,
      firstTimeLoad: true,
      units: [],
      quotas: [],
      unit: '',
      quota: '',
      message: '',
      applicant: {},
      application: {},
      examResult: {},
      examMarks: {},
      isDownloadingRESULT: false,
      resultProgress: 'Preparing...'

    }
  },
  created() {
    /*console.log("ProfileResult::props['applications']=>", this.applications);*/
    for (let i = 0; i < this.applications.length; ++i) {
      if (this.applications[i].status == 'paid') {
        this.units.push(this.applications[i].unit);
      }
    }
    this.onResultLoading = false;
    //this.getQuotaValues();
    //this.getUnitValues();
  },

  methods: {

    selectUnit(value) {
    this.unit = value;
    this.getQuotaValues(); // 🔥 force trigger
  },

    async downloadRESULT() {
      if (this.isDownloadingRESULT) {
        return
      }

      this.isDownloadingRESULT = true
      this.resultProgress = 'Preparing...'

      try {
        await ResultGenerator.generateResult(
          this.unit,
          this.quota,
          (message, progress) => {
            this.resultProgress = message
          },
          (error) => {
            console.error('RESULT generation error:', error)
            this.$iziToast.error({
              title: 'Error',
              message: error.message || 'Failed to generate RESULT. Please try again.'
            })
          }
        )


        // Success notification
        this.$iziToast.success({
          title: 'Success',
          message: 'RESULT downloaded successfully!'
        })
      } catch (error) {
        console.error('RESULT download error:', error)
        this.$iziToast.error({
          title: 'Error',
          message: error.message || 'Failed to download RESULT. Please try again.'
        })
      } finally {
        this.isDownloadingRESULT = false
        this.resultProgress = 'Preparing...'
      }
    },

    convert12HFormat(time) {
      let times = time.split(":")
      let hour = parseInt(time);
      let ampm = ' AM';

      if (hour > 11) {
        ampm = ' PM'
        if (hour != 12) {
          hour -= 12;
        }
      } else if (hour == 0) {
        hour = 12;
      }
      if (times.length > 1) {
        return hour + ':' + times[1] + ampm;
      } else {
        return hour + ampm;
      }
    },

    async getQuotaValues() {

      this.onResultLoading = true;

      /*if(this.firstTimeLoad){
        if(this.units.length>0)
          this.unit = this.units[0];
      }*/

      var data = await GET(GET_EXAM_RESULT + this.unit);
      /*console.log('Selected Quotas:', data.data.quotas);*/

      this.quotas = data.data.quotas;

      this.onResultLoading = false;
      this.firstTimeLoad = true;

      this.quota = '';
      //this.getUnitValues();
    },

    async getExamResult() {

      this.onResultLoading = true;
      this.firstTimeLoad = false;

      /*if(this.firstTimeLoad){
        if(this.quotas.length>0)
          this.quota = this.quotas[0];
      }*/

      var data = await GET(GET_EXAM_RESULT + this.unit + '/' + this.quota);

      // console.log(data.data);

      if (data.data.status == 'success') {
        this.applicant = data.data.applicant;
        this.application = data.data.application;
        this.examResult = data.data.result;
        this.examMarks = data.data.marks;

        this.message = '';
      }
      else {
        this.message = 'data.data.message';
        if (data.data.message) {
          /*this.$iziToast.error({
            //title: 'Admit Card',
            message: data.data.message
          });*/
          this.message = data.data.message;
        }
        else
          this.message = '';
      }

      this.onResultLoading = false;
      this.firstTimeLoad = false;
    },

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Container: Flexbox with wrapping and centered last row */
.unit-selection-grid, .quota-selection-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 15px;           /* spacing between cards */
  padding: 5px 5px;
  justify-content: flex-start;  /* center all rows including last row */
  overflow: visible;        /* ensure hover shadows are visible */
}

/* Unit Card Styling - Fixed size */
.unit-card {
  position: relative;
  z-index: 1;                 /* ensure hover shadows appear above others */
  background: #ffffff;
  border: 2px solid #e0e7ff;
  border-radius: 12px;
  padding: 10px 15px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: center;
  min-height: 80px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 120px;    /* FIXED width */
  flex: 0 0 auto;  /* prevent stretching */
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
}

/* Hover Effect */
.unit-card:hover {
  transform: translateY(-3px) translateZ(0); /* ensure smooth hover */
  box-shadow: 0 8px 16px rgba(99, 102, 241, 0.15);
  border-color: #a5b4fc;
}

/* Eligible Unit */
.unit-card-eligible {
  border-color: #e0e7ff;
  background: linear-gradient(135deg, #ffffff 0%, #f8faff 100%);
}

.unit-card-eligible:hover {
  border-color: #818cf8;
}

/* Selected Unit */
.unit-card-selected {
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  border-color: #4f46e5;
  box-shadow: 0 8px 20px rgba(99, 102, 241, 0.4);
}

.unit-card-selected:hover {
  transform: translateY(-3px) translateZ(0);
  box-shadow: 0 12px 24px rgba(99, 102, 241, 0.5);
}

.unit-card-selected .unit-label {
  color: #ffffff;
  font-weight: 700;
}

.unit-card-selected .unit-check-indicator i {
  color: #ffffff;
}

/* Ineligible Unit */
.unit-card-ineligible {
  background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
  border-color: #fecaca;
  opacity: 0.75;
  cursor: not-allowed;
}

.unit-card-ineligible:hover {
  transform: none;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.04);
  border-color: #fecaca;
}

.unit-card-ineligible .unit-label {
  color: #991b1b;
}

/* Hide the actual radio input */
.unit-radio-hidden {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}

/* Unit Card Content */
.unit-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  width: 100%;
}

/* Check Indicator */
.unit-check-indicator {
  font-size: 24px;
  margin-bottom: 5px;
}

.unit-check-indicator i {
  color: #6366f1;
  transition: all 0.3s ease;
}

.unit-card:hover .unit-check-indicator i {
  transform: scale(1.1);
}

/* Unit Label */
.unit-label {
  font-size: 20px;
  font-weight: 600;
  color: #1e293b;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

/* Status Badge for Ineligible Units */
.unit-status-badge {
  font-size: 11px;
  font-weight: 600;
  color: #dc2626;
  background: #ffffff;
  padding: 4px 10px;
  border-radius: 12px;
  margin-top: 5px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  box-shadow: 0 2px 4px rgba(220, 38, 38, 0.15);
}

.unit-status-badge i {
  font-size: 12px;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .unit-card {
    width: 100px;
    min-height: 100px;
  }
}

@media (max-width: 480px) {
  .unit-card {
    width: 90px;
    min-height: 90px;
    padding: 12px 10px;
  }

  .unit-label {
    font-size: 16px;
  }

  .unit-check-indicator {
    font-size: 20px;
  }
}

/* Input fix */
.theme-form input[type="text"] {
  min-width: 100% !important;
}


.loader {
  margin-top: 20%;
}

.d-flex {
  padding: 10px;
  /* margin: 10px; */
  -webkit-box-shadow: 1px 0 15px 2px #c1b3b3;
  box-shadow: 1px 0 15px 2px #c1b3b3;
}

.home-page {
  background: url(../../assets/bg.svg);
  background-size: cover;
  /*font-family: 'Poppins', sans-serif;*/
}

.home-page section {
  padding: 5px 0px;
}

/* Header */


.img-fluid {
  max-width: 100%;
}


/* advantages */
.advantages {
  -webkit-box-shadow: 0px 3px 10px 0px #dadada;
  -moz-box-shadow: 0px 3px 10px 0px #dadada;
  box-shadow: 0px 3px 10px 0px #dadada;
}

.main-img-logo {
  background: rgba(245, 222, 179, 0.5);
  margin: 4px;
  padding: 8px;
}

* {
  box-sizing: border-box;
}

.flower-spinner {
  margin: auto;
}

.table td,
.table th {
  padding: .5rem;
  vertical-align: top;
  border-bottom: 1px solid darkgray;
  text-color: black;
}

.table td {
  font-weight: normal;
}

.table th {
  font-weight: bold;
}

.text-normal {
  font-weight: normal;
}

.text-bold {
  font-weight: bold;
}
</style>
